import makeStyles from '@mui/styles/makeStyles';

// istanbul ignore next
const getColumns = (count) => `repeat(${count}, minmax(275px, 1fr))`;

// istanbul ignore next
const useStyles = makeStyles((theme) => ({
    grid: {
        '@media (min-width: 600px)': {
            gridTemplateColumns: getColumns(2),
        },
        // eslint-disable-next-line sort-keys
        '@media (min-width: 1200px)': {
            gridTemplateColumns: getColumns(3),
        },
        '@media (min-width: 1600px)': {
            gridTemplateColumns: getColumns(4),
        },
        '@media (min-width: 2000px)': {
            gridTemplateColumns: getColumns(5),
        },
        '@media (min-width: 2400px)': {
            gridTemplateColumns: getColumns(6),
        },
        '@media (min-width: 2800px)': {
            gridTemplateColumns: getColumns(7),
        },
        '@media (min-width: 3200px)': {
            gridTemplateColumns: getColumns(8),
        },
        '@media (min-width: 3600px)': {
            gridTemplateColumns: getColumns(9),
        },
        columnGap: theme.spacing(3),
        display: 'grid',
        gridTemplateColumns: getColumns(1),
        justifyItems: 'center',
        rowGap: theme.spacing(1),
    },
}));

export default useStyles;
